/**
 * ETIQUETA VISIBLE DE ROL
 *
 * `ENCARGADO` sigue siendo el código interno (el que viaja en la API, el
 * que decide `puede()`, el que aparece en `usuario_rol.codigo`) — esto es
 * sólo la traducción para pantalla. Desde FASE 3.3-A se muestra como
 * «Supervisor»: es el mismo rol, sólo cambia cómo se nombra en la UI.
 *
 * Compartido entre `componentes/shell.tsx` (pie de la barra lateral) y
 * `paginas/usuarios.tsx` (ficha, alta, cambio de rol, histórico) para que
 * cambiar un nombre visible no signifique buscarlo en dos sitios.
 */
export const ETIQUETA_ROL: Record<string, string> = {
  ADMIN: 'Admin',
  CONSULTOR: 'Consultor',
  ENCARGADO: 'Supervisor',
  OPERARIO: 'Operario',
  CLIENTE: 'Cliente',
  PLANIFICADOR: 'Planificador',
  //  FASE 8.1 — Mantenimiento.
  TECNICO_MANTENIMIENTO: 'Técnico de mantenimiento',
};

export function etiquetaRol(codigo: string): string {
  return ETIQUETA_ROL[codigo] ?? codigo;
}
